import { ServerDataSource } from 'angular2-smart-table';
import { Department } from './department';
import { JobRole, Person } from './person';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { EntityConfigTemplate } from './common/entity-config.interface';

const dPipe: DatePipe = new DatePipe('en');

export const AssignmentConfig: EntityConfigTemplate = {
  meta: { entityName: 'assignment', entityPluralName: 'assignments', titleField: 'title', view: false, attachedToField: 'person' },
  isPrimary: { title: 'Primary', type: 'select', options: [{ value: true, title: 'Yes' }, { value: false, title: 'No' }], default: false,
    valuePrep: (_: any, row: Assignment) => row?.isPrimary ? 'Yes' : 'No' },
  'role.title': { isForeignKey: true, type:'relation', title: 'Role', valuePrep: (_:any, row: Assignment) => row?.role?.title ?? '', filterFunction: roleFilterFunc },
  'department.name': {  isForeignKey: true, type: 'relation', title: 'Department', valuePrep: (_:any, row: Assignment) => row?.department?.name ?? '',
    filterFunction: departmentFilterFunc, valueStoreFunction: (_:any, row: Assignment) => row?.department?.name ?? ''  },
  'salary-structure': { isForeignKey: true, type: 'relation', title: 'Salary Structure',
    valuePrep: (_:any, row: Assignment) => row?.salaryStructure?.name ?? '' },
  baseSalary: { title: 'Base Salary', type: 'number', default: null },
  baseSalaryCurrency: { title: 'Currency', type: 'text', default: 'USD' },
  startDate: { title: 'Start Date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), type: 'date' },
  endDate: { title: 'End Date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), type: 'date', view: { list: false } },
  person: { view: false, isPrefilled: true, isForeignKey: true, title: 'Person', valuePrep: (_:any, row: Assignment) => `${row?.person?.firstName} ${row?.person?.lastName}`  },
};

function departmentFilterFunc(cell?: any, search?: string): boolean {
  return true;
}

function roleFilterFunc(cell?: any, search?: string): boolean {
  if (!search) {
    return true;
  }
  const roleTitle: string = cell?.role?.title ?? '';
  return roleTitle.toLowerCase().includes(search.toLowerCase());
}
export interface SalaryStructureRef {
  id?: number;
  documentId?: string;
  name: string;
  erpnextStructureId?: string;
}

export interface Assignment {
  id: number;
  documentId?: string;
  isPrimary?: boolean;
  role?: JobRole;
  department?: Department;
  salaryStructure?: SalaryStructureRef;
  baseSalary?: number;
  baseSalaryCurrency?: string;
  startDate: string;
  endDate?: string;
  person?: Person;
}

export abstract class AssignmentData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Person[]>;
  abstract get(id: number): Observable<Person>;
  abstract update(Book: Person): Observable<Person>;
  abstract create(Person: Person): Observable<Person>;
  abstract delete(id: string): Observable<boolean>;
}

